import React from "react";

const GridBackground = ({ width, height, color }) => {
  return <rect x={0} y={0} width={width} height={height} fill={color} />;
};

export default GridBackground;
